import React from 'react'
import { connect } from 'react-redux'
import { DragDropContext } from 'react-beautiful-dnd'
import styled from 'styled-components'
import { addRule, reorderRule } from '../../actioncreators/actioncreators'
import RuleRow from './ruleRow'
import { getRuleRowIndexFromDroppableId } from '../../dndIdHandler'

const { Component } = React

const RuleRowContainer = styled.div`
  margin-top: 10px;
  padding: 0px 10px;
`

class Rules extends Component {
  constructor (props) {
    super(props)

    this.onDragEnd = this.onDragEnd.bind(this)
    this.onRuleDragEnd = this.onRuleDragEnd.bind(this)
    this.onExampleDragEnd = this.onExampleDragEnd.bind(this)
  }

  onRuleDragEnd (source, destination) {
    let exampleCollapseIndicators = document.getElementsByClassName('exampleCollapseIndicator')
    Array.prototype.forEach.call(exampleCollapseIndicators, function (el) {
      el.style.display = 'none'
    })

    let collapsibleExamples = document.getElementsByClassName('collapsibleExamples')
    Array.prototype.forEach.call(collapsibleExamples, function (el) {
      el.style.display = 'block'
    })

    if (!destination) {
      return
    }

    if (destination.droppableId === source.droppableId &&
        destination.index === source.index) {
      return
    }

    const sourceRuleRowIndex =
      getRuleRowIndexFromDroppableId(source.droppableId)

    const destinationRuleRowIndex =
      getRuleRowIndexFromDroppableId(destination.droppableId)

    this.props.reorderRule(
      sourceRuleRowIndex,
      source.index,
      destinationRuleRowIndex,
      destination.index)
  }

  onExampleDragEnd (source, destination) {
    console.log('onExampleDragEnd')
  }

  onDragEnd (result) {
    const { destination, source } = result

    if (result.type === 'rule') {
      this.onRuleDragEnd(source, destination)
    } else {
      this.onExampleDragEnd(source, destination)
    }
  }

  render () {
    var rows = this.props.rules.map((ruleRow, index) => {
      return (<RuleRow
        key={index}
        ruleRowIndex={index}
        rules={ruleRow}
      />)
    })

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <RuleRowContainer>
          {rows}
        </RuleRowContainer>
      </DragDropContext>
    )
  }
}

const mapStateToProps = function (store, ownProps) {
  return {
    rules: store.rules
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    addRule: (id) => dispatch(addRule(id)),
    reorderRule: (
      sourceRuleRowIndex,
      sourceRuleIndex,
      destinationRuleRowIndex,
      destinationRuleIndex) => dispatch(reorderRule(
      sourceRuleRowIndex,
      sourceRuleIndex,
      destinationRuleRowIndex,
      destinationRuleIndex))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Rules)
